<template>
  <div class="level">
    <van-nav-bar
      title="添加银行卡"
      @click-left="onClickLeft"
      left-arrow
    ></van-nav-bar>
    <!-- <div class="level_con">
      <div
        style="padding: 15px; background:linear-gradient(to right,#00AEDE,#5683D5);font-weight:bold; color: #ffffff; border-radius: 6px; margin-bottom: 20px"
      >
        <div style="display: flex; justify-content: space-between">
          <van-switch
            v-model="checked"
            size="24px"
            active-color="#07c160"
            inactive-color="#dcdee0"
          />
          <div>{{ type }}</div>
        </div>
        <div style="margin: 20px 0;">
          {{ card.slice(0, 5) }} {{ card.slice(5, 10) }}
          {{ card.slice(10, 15) }} {{ card.slice(15, 19) }}
        </div>
        <div style="display: flex; justify-content: space-between;">
          <div>
            <div style="margin-bottom: 5px">持卡人姓名</div>
            <div>{{ realname }}</div>
          </div>
        </div>
      </div>
    </div> -->
    <div style="padding:10px;border-radius:6px;overflow: hidden;">
      <img
        style="width: 100%;border-radius:6px;"
        src="../../../assets/images/new/qukuan.png"
        alt=""
      />
    </div>
    <div style="background: #ffffff;  border-radius: 2px; margin-bottom: 20px">
      <div
        style="border-bottom:1px solid #eee;height: 60px; display:flex;align-items:center;padding:0 15px;"
      >
        <span style="width: 120px;font-size:16px;margin-right:20px;"
          >银行卡号</span
        >
        <field v-model="card" placeholder="请输入银行卡号" />
      </div>
      <div
        style="border-bottom:1px solid #eee;display:flex;align-items:center;padding:0 15px;"
      >
        <span style="width: 120px;font-size:16px;margin-right:20px;"
          >银行类型</span
        >
        <field v-model="type" placeholder="请输入银行类型" />
      </div>
      <div
        style="border-bottom:1px solid #eee;display:flex;align-items:center;padding:0 15px;"
      >
        <span style="width: 120px;font-size:16px;margin-right:20px;"
          >开户行</span
        >
        <field v-model="branch" placeholder="请输入开户行" />
      </div>
      <div
        style="border-bottom:1px solid #eee;display:flex;align-items:center;padding:0 15px;"
      >
        <span style="width: 120px;font-size:16px;margin-right:20px;"
          >支付密码</span
        >
        <field v-model="password" placeholder="请输入支付密码" />
      </div>
    </div>
    <div style="display: flex; justify-content: center;padding:30px;">
      <van-button class="register_submit" style="width: 100%" @click="save"
        >添加</van-button
      >
    </div>
    <div
      v-if="show"
      style="background: rgba(0, 0, 0, 0.5);position: fixed;width: 100%;height: 100%;left:0;top:0;display: flex;align-items: center;justify-content: center;"
    >
      <div
        style="background: rgba(0, 0, 0, 0.7);width:130px;height:130px;border-radius:8px;text-align:center;line-height:130px;color:#fff;font-size:16px;"
      >
        提交中
      </div>
    </div>
    <div style="height: 70px;"></div>
  </div>
</template>

<script>
import { getUserInfo } from "../../../api/user";
import { addBank } from "../../../api/public";
import Icon from "vant/lib/icon";
import Field from "vant/lib/field";
import vanSwitch from "vant/lib/switch";
import vanButton from "vant/lib/button";
// import Toast from "vant/lib/toast";
import "vant/lib/field/style";
import "vant/lib/switch/style";
import "vant/lib/button/style";
// import "vant/lib/toast/style";
export default {
  name: "add",
  components: {
    Field,
    Icon,

    vanSwitch,
    vanButton
  },
  data() {
    return {
      show: false,
      checked: false,
      type: "",
      realname: "",
      card: "",
      branch: "",
      password: ""
    };
  },
  mounted() {
    getUserInfo().then(res => {
      if (res.data.data.is_auth === 0) {
        // Toast("请先完成实名认证");
        this.$router.push({ name: "memmber_business" });
      } else {
        this.realname = res.data.data.realname;
      }
    });
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    save() {
      let that = this;
      if (!this.card) {
        // Toast("请填写卡号");
        that.$dialog.error("请填写卡号");
        return false;
      }
      if (!this.branch) {
        // Toast("请填写开户行");
        that.$dialog.error("请填写开户行");
        return false;
      }
      if (!this.type) {
        // Toast("请填写银行类型");
        that.$dialog.error("请填写银行类型");
        return false;
      }
      if (!this.password) {
        // Toast("请填写银行类型");
        that.$dialog.error("请填写支付密码");
        return false;
      }
      that.show = true;
      addBank({
        card: this.card,
        branch: this.branch,
        type: this.type,
        pwd: this.password
      })
        .then(() => {
          // Toast("添加成功");
          that.$dialog.success("添加成功");
          this.$router.push({ name: "bank" });
          that.show = false;
        })
        .catch(err => {
          that.$dialog.error(err.response.data.msg);
          that.show = false;
        });
    }
  }
};
</script>

<style scoped lang="less">
.register_submit {
  width: 100%;
  margin: 0 auto;
  height: 45px;
  background: var(--bg-color);
  border-radius: 30px;
  margin-top: 40px;
  text-align: center;
  line-height: 45px;
  color: #ffffff;
  border: 0px solid;
  font-size: 15px;
  font-weight: bold;
}
/deep/ .van-nav-bar {
  background: #fff;
}
/deep/ .van-nav-bar .van-icon {
  color: #000;
}
/deep/ .van-nav-bar__title {
  color: #000;
}
.jiangli_top {
  width: 100%;
  height: 50px;
  background-color: #ffffff;
  position: relative;
}
.jiangli_top i {
  cursor: pointer;
  font-size: 24px;
  position: absolute;
  top: 13px;
  width: 24px;
  height: 24px;
  left: 16px;
}
.level_con {
  padding: 20px 15px;
  padding-bottom: 0;
}
.van-cell {
  padding: 16px;
}
.van-cell::after {
  border-color: #c7c7c7;
}
</style>

